import { ActionType, useActionState } from '../../../status/state/actions.state';
import Modal, { Theatre } from '@ingka/modal';
import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { useMemo, useState } from 'react';

import { BulkEditTable } from './BulkEditTable';
import { BulkEditToolbar } from './BulkEditToolbar';
import { CloseIconButton } from '../../../../shared/components/IconButton';
import { LoadingIndicator } from "../../../../shared/components/TableLoadingIndicator";
import { ModalCloseButton } from '../../../../shared/styles/components/modal.styles';
import editIcon from '@ingka/ssr-icon/paths/pencil';
import shallow from 'zustand/shallow';
import styled from '@emotion/styled';
import { useBulkEditState } from './bulk-edit.state';
import { useSubItemsFromSelections } from '../../state/selection.state';

export const BulkEditTheatre = () => {
   const [isOpen, setIsOpen] = useState(false);
   const [actionType] = useActionState((state) => [state.actionType], shallow);

   const subItemsFromSelections = useSubItemsFromSelections();

   const onClose = () => {
      setIsOpen(false);
      useBulkEditState.setState({ rowSelection: {}, selectedIds: new Set() });
   };

   const tooltipText = useMemo(
      () => (subItemsFromSelections.length !== 0 ? 'Bulk edit selected unlocked rows' : 'You need to make a selection to bulk edit'),
      [subItemsFromSelections]
   );

   const isActionSheetOpen = actionType !== ActionType.none;

   return (
      <>
         <StyledTooltip title={tooltipText}>
            <span>
               <StyledToolbarButton
                  onClick={() => {
                     setIsOpen(true);
                  }}
                  ssrIcon={editIcon}
                  text="Filter"
                  iconOnly={true}
                  small={true}
                  disabled={subItemsFromSelections.length === 0}
               />
            </span>
         </StyledTooltip>
         {isOpen && (
            <div {...(isActionSheetOpen && { inert: '' as any })}>
               <Modal visible={isOpen} handleCloseBtn={onClose} escapable={false}>
                  <StyledTheatre
                     header={
                        <StyledHeaderDiv>
                           <h2>Edit common parts <LoadingIndicator /></h2>
                           <div>Select what part you want to edit for the selected items</div>
                           <ModalCloseButton>
                              <CloseIconButton onClick={onClose} />
                           </ModalCloseButton>
                        </StyledHeaderDiv>
                     }
                  >
                     <StyledTheatreContentDiv>
                        <BulkEditToolbar />

                        <BulkEditTable />
                     </StyledTheatreContentDiv>
                  </StyledTheatre>
               </Modal>
            </div>
         )}
      </>
   );
};

const StyledTheatre = styled(Theatre)`
   width: calc(100% - 6rem);
   height: calc(100% - 6rem);
   left: 3rem;
   top: 3rem;
   border-radius: 0;

   .theatre__content-wrapper {
      display: flex;
      flex-direction: column;
      overflow: hidden;
   }
`;

const StyledHeaderDiv = styled.div`
   padding: 3rem 4rem 2rem;
`;

const StyledTheatreContentDiv = styled.div`
   padding: 0 4rem 4rem;
   min-height: 0;
   display: flex;
   flex-direction: column;
   overflow: hidden;
`;
